/**
 * Utility to immediately reveal elements above the fold on desktop
 * This prevents the fading effect on initial load for desktop views
 */
export const setupImmediateReveal = () => {
  // Only apply on desktop
  if (window.innerWidth >= 768) {
    // Select all animation elements in the top section of the page
    const viewportHeight = window.innerHeight;
    const elementsAboveFold = document.querySelectorAll(
      ".reveal-bottom, .reveal-left, .reveal-right"
    );

    elementsAboveFold.forEach((element) => {
      const rect = element.getBoundingClientRect();

      // If element is visible in viewport or above the fold
      if (rect.top < viewportHeight) {
        // Immediately make fully visible without animation
        element.classList.add("above-fold");
        element.classList.add("active");
        element.classList.remove("pre-active", "visible-on-scroll");

        // Force immediate rendering without transition
        element.style.transition = "none";
        element.style.opacity = "1";
        element.style.transform = "none";

        // Restore transition after a small delay
        setTimeout(() => {
          element.style.transition = "";
        }, 100);
      }
    });
  }
};

/**
 * Add this to your App component's useEffect
 * to apply immediate reveal on initial load
 */
export const setupDesktopReveal = () => {
  if (window.innerWidth >= 768) {
    // On first load, mark the body to prevent unnecessary animations
    document.body.classList.add("desktop-view");

    // Run immediate reveal after DOM is fully loaded
    if (document.readyState === "complete") {
      setupImmediateReveal();
    } else {
      window.addEventListener("load", setupImmediateReveal);
    }
  }
};
